export const Isolated = "isolated";
export const Hero = "hero";
export const Hero1080 = "hero1080";
export const Isolated424 = "isolated424";
export const Isolated328 = "isolated328";
export const Isolated1036 = "isolated1036";
